import { CoralException } from '@ch-types/CoralException';

export default class AccessDeniedException extends CoralException {}
